/* eslint-disable react/prop-types */
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import { Box, CircularProgress } from '@mui/material'
import { circularProgressClasses } from '@mui/material/CircularProgress'
import dayjs from 'dayjs'
import React from 'react'

// The main attendance page's own card chrome, so an apartment session card is
// the same object as a centre session card, not a lookalike.
import * as styles from 'app/pages/Attendance/styles'
import { colors } from 'app/theme/colors'

// Copied from Attendance/components/Card.js: a background track ring plus a
// determinate value ring, with `attended/expected` centred inside. Red once the
// session is over, teal while it is still to come.
const AttendanceRing = ({ value, iscolorenabled, label }) => (
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    <CircularProgress
      variant="determinate"
      value={100}
      size={40}
      thickness={4}
      sx={{ color: iscolorenabled ? colors.ohRed : colors.ohGray }}
    />
    <CircularProgress
      variant="determinate"
      disableShrink
      value={value}
      size={40}
      thickness={4}
      sx={{
        color: iscolorenabled ? colors.ohRed : colors.ohTeal,
        position: 'absolute',
        left: 0,
        [`& .${circularProgressClasses.circle}`]: { strokeLinecap: 'round' }
      }}
    />
    <Box
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11
      }}
    >
      {label}
    </Box>
  </Box>
)

export const SessionCard = ({ session }) => {
  const attended = session.presentCount || 0
  const expected = session.expectedCount || 0
  const pct = expected ? Math.min((attended / expected) * 100, 100) : 0
  // Red once the session has ended, exactly as `iscolorenabled` does on the
  // main card.
  const isOver = dayjs(session.endDatetime).isBefore(dayjs())

  return (
    <styles.CardContainer>
      <styles.CardHeader
        batchTypeColor={isOver ? 'rgba(0,0,0,0.36)' : colors.ohOrange}
      >
        <styles.Room>
          <styles.Time>
            <styles.Icon>
              <AccessTimeIcon fontSize="inherit" />
            </styles.Icon>
            <styles.Boldtext>
              {dayjs(session.start_datetime).format('h:mmA')} -{' '}
              {dayjs(session.endDatetime).format('h:mmA')}
            </styles.Boldtext>
          </styles.Time>
        </styles.Room>
        <styles.Mediumheading>{session.computedStatus}</styles.Mediumheading>
      </styles.CardHeader>
      <styles.CardBody>
        <styles.Info>
          <styles.Subtitle>{session.batchName || '—'}</styles.Subtitle>
          <styles.Name>{session.programName}</styles.Name>
          <styles.Subheading>
            {session.teacherName ? `with ${session.teacherName}` : 'no teacher'}
          </styles.Subheading>
        </styles.Info>
        <styles.Attendance>
          <AttendanceRing
            value={pct}
            iscolorenabled={isOver}
            label={`${attended}/${expected}`}
          />
        </styles.Attendance>
      </styles.CardBody>
    </styles.CardContainer>
  )
}

export default SessionCard
